import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Collapse, Tabs } from "antd";
import React, { ReactNode, useMemo } from 'react';
import { getTrackingOp, setTrackingOp, useTrackingOp } from "../../../contexts/TrackingOpContext";
import { VesselSideService } from "../../../util/services/vessel-side";
import { IChecklist } from "../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../util/varibles/message";
import Checklist from "../../Checklist";
import styles from './style.module.scss';

const Checklists: React.FC<{ data: IChecklist[], status: { [id: string]: number } }> = ({ data, status = {} }) => {
    const get = getTrackingOp();
    const set = setTrackingOp();

    const { op } = get();
    if (!op)
        return null;

    const handleSubmit = (checklist: IChecklist) => {
        const { id, tenant_id } = op.operation;
        return VesselSideService.updateChecklist({
            operation_id: id,
            tenant_id,
            checklists_v2: data.map(item => item.id === checklist.id ? checklist : item)
        })
            .then(rs => {
                set({ op: { ...op, operation: { ...op.operation, checklists_v2: rs } } })
                notify.success(NotifyCode.S2)([checklist.name])
            })
    }

    return <Collapse
        className={styles.checklists}
        bordered={false}
        expandIconPlacement='end'
        expandIcon={props => props.isActive ?
            <MinusCircleOutlined style={{ fontSize: '18px' }} /> :
            <PlusCircleOutlined style={{ fontSize: '18px' }} />
        }
        items={data.map(item => {
            const { name = '' } = item || {};

            return {
                key: item.id,
                label: name,
                className: 'mb-2',
                children: <Checklist
                    checklist={item}
                    vesselTenantId={op.vessel?.tenant_id}
                    onSubmit={handleSubmit}
                />
            }
        })}
    />
}

interface IProps {
    children: [ReactNode, ReactNode]
}

const TabControl: React.FC<IProps> = ({ children }) => {
    const [Info, ActivityLog] = children;
    const [checklists_v2 = []] = useTrackingOp(state => state.op?.operation.checklists_v2);

    const activityLog = {
        label: 'Activity log',
        key: 'activity_log',
        children: <div className={styles.activityLog}>
            {ActivityLog}
        </div>,
    }

    const { checklistName, checklistStatus = {} } = useMemo(() => {
        const name = "Checklists";
        const max = checklists_v2.length;
        if (max > 0) {
            let count = 0, checklistStatus: { [id: string]: number } = {};
            checklists_v2.forEach((item, i) => {
                const { result: resultText = JSON.stringify({}) } = item;

                try {
                    const result = JSON.parse(resultText);
                    const incomplete = Object.keys(result).length === 0
                    if (!incomplete) {
                        count++;
                        checklistStatus[`${i}`] = 1
                    } else {
                        checklistStatus[`${i}`] = Object.keys(result).length > 0 ? 0 : -1;
                    }
                } catch (error) {
                    console.log("Json error: Tracking, ", error);
                    checklistStatus[`${i}`] = -1
                }
            });
            return { checklistName: name + `(${count}/${max})`, checklistStatus }
        }

        return { checklistName: name }
    }, [checklists_v2])

    return <Tabs
        defaultActiveKey="info"
        className='max-h-[calc(100%-46px)] overflow-auto'
        tabBarStyle={{
            height: '36px',
            marginBottom: '10px',
            position: 'sticky',
            top: 0,
            background: 'var(--bgHeader)!important',
            zIndex: 1,
        }}
        items={[
            {
                label: 'Operation workflow',
                key: 'info',
                children: Info,
            },
            ...(checklists_v2.length > 0 ? [{
                label: checklistName,
                key: 'checklist',
                children: <Checklists data={checklists_v2} status={checklistStatus} />,
            }, activityLog] : [activityLog]),
        ]}
    />;
};

export default TabControl;
